import React from 'react';
import './About.scss';
import Experience from '../../components/Experience/Experience';
import Cover from '../../components/Cover/Cover';
import EducationItem from '../../components/EducationItem/EducationItem';
import lightroom from '../../assets/images/Lightroom.svg';
import photoshop from '../../assets/images/Photoshop.svg';
import xd from '../../assets/images/Xd.svg';
import illustrator from '../../assets/images/Illustrator.svg';
import afterEffects from '../../assets/images/AfterEffects.svg';
import premierePro from '../../assets/images/PremierePro.svg';
import figma from '../../assets/images/Figma.svg';
import proCreate from '../../assets/images/ProCreate.svg';
import framer from '../../assets/images/Framer.svg';
import slack from '../../assets/images/Slack.svg';
import claude from '../../assets/images/Claude.svg';
import claudeCode from '../../assets/images/ClaudeCode.svg';
import cursor from '../../assets/images/Cursor.svg';
import figmaMake from '../../assets/images/FigmaMake.svg';
import github from '../../assets/images/GitHub.svg';
import FadeInSection from '../../components/FadeInSection';
import coverImage from '../../assets/images/about__cover.png';
import SkeletonPage from '../../components/SkeletonPage/SkeletonPage';

import {
  arielData,
  awwwardsData,
  bbeMotionData,
  googleUxData,
  practicumProductData,
  practicumUxData,
  witteData,
  uxcelMotionData,
  memoriselyData,
} from '../../constants/educationData';

const About = () => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);
  const technologyStack = [
    { image: lightroom, name: 'Lightroom' },
    { image: photoshop, name: 'Photoshop' },
    { image: xd, name: 'Xd' },
    { image: illustrator, name: 'Illustrator' },
    { image: afterEffects, name: 'After Effects' },
    { image: premierePro, name: 'Premiere Pro' },

    { image: proCreate, name: 'ProCreate' },
    { image: slack, name: 'Slack' },
    { image: claude, name: 'Claude' },
    { image: claudeCode, name: 'Claude Code' },
    { image: cursor, name: 'Cursor' },
    { image: figma, name: 'Figma' },
    { image: figmaMake, name: 'Figma Make' },
    { image: github, name: 'GitHub' },
    { image: framer, name: 'Framer' },
  ];

  React.useEffect(() => {
    // Создаем объект Image для предварительной загрузки
    const img = new Image();
    img.src = coverImage; // Укажите URL изображения

    // Устанавливаем слушатель загрузки для обновления состояния
    img.onload = () => {
      setIsImageLoaded(true);
    };

    // Обработка ошибки (если изображение не загружается)
    img.onerror = () => {
      console.error('Ошибка загрузки изображения');
      setIsImageLoaded(true); // Загрузить страницу, даже если изображение не загрузилось
    };
  }, []);

  return (
    <>
      {!isImageLoaded && <SkeletonPage />}
      {isImageLoaded && (
        <section className="about">
          <FadeInSection>
            <Cover coverImage={coverImage} />
          </FadeInSection>
          <FadeInSection>
            <Experience />
          </FadeInSection>
          <article className="about__education education">
            <FadeInSection>
              <h2 className="education__title">Education</h2>
            </FadeInSection>
            <div className="education__content">
              <FadeInSection>
                <EducationItem {...memoriselyData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...bbeMotionData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...uxcelMotionData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...awwwardsData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...practicumProductData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...googleUxData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...practicumUxData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...arielData} />
              </FadeInSection>
              <FadeInSection>
                <EducationItem {...witteData} />
              </FadeInSection>
            </div>
          </article>
          <article className="carousel">
            <FadeInSection>
              <h2 className="education__title">Technology stack</h2>
            </FadeInSection>
            <FadeInSection>
              <div className="carousel__viewport">
                <div
                  className="carousel__track"
                  style={{ '--carousel-item-count': technologyStack.length }}>
                  {[...technologyStack, ...technologyStack].map((technology, index) => (
                    <div className="carousel__image" key={`${technology.name}-${index}`}>
                      <img src={technology.image} alt={technology.name} />
                      <span>{technology.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </FadeInSection>
          </article>
          <article className="about__skills skills">
            <FadeInSection>
              <h2 className="education__title">Skills & Proficiency</h2>
            </FadeInSection>
            <div className="skills__content">
              <FadeInSection>
                <div className="skills__text-container">
                  <h3 className="skills__skill-name">Hard skills</h3>
                  <p className="skills__skill-text">
                    Experienced in product discovery, interaction design, and scalable design
                    systems with a strong focus on <span>solving complex product challenges</span>{' '}
                    and <span>AI-native workflows</span>
                  </p>
                </div>{' '}
              </FadeInSection>
              <FadeInSection>
                <div className="skills__text-container">
                  <h3 className="skills__skill-name">Soft skills</h3>
                  <p className="skills__skill-text">
                    I value clear communication,{' '}
                    <span>thoughtful collaboration, and structured problem-solving.</span> I’m able
                    to <span>prioritize, meet deadlines, and take ownership</span> in fast-moving
                    product environments. Volunteering for over 5 years also helped me develop
                    strong <span>user empathy</span>
                  </p>
                </div>
              </FadeInSection>
              <FadeInSection>
                <div className="skills__text-container">
                  <h3 className="skills__skill-name">Tools</h3>
                  <p className="skills__skill-text">
                    My core toolkit is built around{' '}
                    <span>
                      Figma, Claude Code, Cursor, Storybook, GitHub, ChatGPT, Gemini, Figma Make,
                    </span>
                    Adobe CC, and UX Pilot. I use these tools across product design, AI-assisted
                    workflows, and design-to-development collaboration, while{' '}
                    <span>Maze and Mixpanel</span> support research validation and product insights
                  </p>
                </div>
              </FadeInSection>
              <FadeInSection>
                <div className="skills__text-container">
                  <h3 className="skills__skill-name">Languages</h3>
                  <p className="skills__skill-text">
                    I speak three languages: <span>English, Hebrew</span> and <span>Russian</span>
                  </p>
                </div>
              </FadeInSection>
            </div>
          </article>
          <div className=""></div>
        </section>
      )}
    </>
  );
};

export default About;
